// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3PoZI","label":"Category_label__2YvwA","content":"Category_content__2wQ9O","header":"Category_header__2JKhu","location":"Category_location__24H1N"};